import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import React from 'react';
import { useIsScreenSize } from '../../../hooks/useIsScreenSize';
import { COLOR } from '../../../styles/colors';
import Icon from '../../../ui/Icon/Icon';
import useSiteNavContext from '../SiteNavContext';
import { SITE_NAV_BREAK_POINT, SITE_NAV_MODE } from '../SiteNavUtils';
import { StyledSiteNavButton } from '../StyledSiteNav';

const SearchButton = () => {
  const { navMode, setNavMode } = useSiteNavContext();

  const isDesktop = useIsScreenSize(SITE_NAV_BREAK_POINT);
  const isSearchOpen = navMode === SITE_NAV_MODE.Search;

  let searchAction;
  if (isDesktop) {
    searchAction = () =>
      setNavMode(isSearchOpen ? SITE_NAV_MODE.None : SITE_NAV_MODE.Search);
  } else {
    searchAction = () => setNavMode(SITE_NAV_MODE.HamburgerMenuSearch);
  }

  return (
    <StyledSiteNavButton onClick={searchAction}>
      <Icon
        icon={isSearchOpen ? faTimes : faSearch}
        color={COLOR.white}
        size={22}
      />
    </StyledSiteNavButton>
  );
};

export default SearchButton;
